/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import AnalyticsService from 'cio/services/analytics';
import { SafeString } from '@ember/template/-private/handlebars';
import AccountService from 'cio/services/account';

interface ActionIntegrationCardArgs {
  cardType?: string;
  icon?: string;
  imageSrc?: string;
  title: string;
  subtitle?: string;
  enabled: boolean;
  description: string;
  name: string;
  category: string;
  routeName: string;
  dynamicSegment?: string;
  type: string;
  external?: boolean;
  public: boolean;
  legacy?: string | SafeString;
  premiumIntegration?: boolean;
  publicType: string;
}

const CAN_TRACK_STATE = ['Segment.com'];

export default class ActionIntegrationCard extends Component<ActionIntegrationCardArgs> {
  @service analytics!: AnalyticsService;
  @service router!: RouterService;
  @service account!: AccountService;

  zapierWordmarkImage = new URL('cio/assets/images/integrations/zapier-wordmark.svg', import.meta.url).toString();

  get isPremiumIntegration() {
    return this.args.premiumIntegration ?? false;
  }

  get isFeatureGated() {
    return this.isPremiumIntegration && !this.account.planFeatures.warehouseSync.enabled;
  }

  get showPremiumLabel() {
    return this.isPremiumIntegration && this.account.planFeatures.warehouseSync.showPremiumLabel;
  }

  @action
  onClick() {
    if (!this.args.name) {
      return;
    }

    let trackData: Record<string, string | boolean | undefined> = {
      from: this.args.public ? 'Public' : 'In-App',
      name: this.args.name,
      category: this.args.category,
      enabled: this.args.enabled,
      type: this.args.type,
    };

    // We only want to send a Disabled status for integrations we can track the state of or can't be "disabled".
    // Everything else should be unset unless it's enabled
    if (!CAN_TRACK_STATE.includes(this.args.name)) {
      trackData.enabled = !!this.args.enabled || undefined;
    }

    if (this.args.subtitle) {
      trackData.subtitle = this.args.subtitle;
    }

    this.analytics.track('integration', 'clicked', trackData);
  }

  @action
  openExternalIntegrationAndShowNotify(evt: Event) {
    evt.stopPropagation();
    evt.preventDefault();

    this.onClick();

    this.router.transitionTo(this.args.routeName, this.args.dynamicSegment!, {
      queryParams: {
        showNotify: true,
      },
    });
  }
}
